import React, { Component } from 'react';

import IconButton from 'material-ui/IconButton';
import AppBar from 'material-ui/AppBar';

import './TopBar.css';

class TopBar extends Component {
  render() {
    return (
      <AppBar
        title={this.props.title}
        style={{willChange: 'transform', userSelect: 'none', WebkitUserSelect: 'none'}}
        iconElementLeft={<IconButton iconClassName="material-icons" onClick={this.props.onBack}>arrow_forward</IconButton>}
      />
    );
  }
}

export default TopBar;



// WEBPACK FOOTER //
// ./src/components/TopBar/TopBar.jsx